import { SVGProps } from "react";

interface ExtendedSVGProps extends SVGProps<SVGSVGElement> {
  showLine?: boolean;
}

const EyeIcon = ({ className, showLine, ...props }: ExtendedSVGProps) => {
  return (
    <div className="relative w-fit">
      <svg
        width="22"
        height="23"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.33573 11.7337L3.32653 11.7449L3.33574 11.756C3.79829 12.3171 4.81084 13.4557 6.159 14.4543C7.50692 15.4526 9.19223 16.3123 10.9999 16.3123C12.8115 16.3123 14.4971 15.453 15.8442 14.455C17.1915 13.4568 18.2022 12.3184 18.6641 11.7568L18.6733 11.7457L18.6641 11.7345C18.2014 11.1731 17.1888 10.0345 15.8406 9.03604C14.4927 8.03778 12.8075 7.17826 10.9999 7.17826C9.18837 7.17826 7.50276 8.03747 6.15565 9.0355C4.8083 10.0337 3.79768 11.1721 3.33573 11.7337ZM10.9999 6.02661C13.4406 6.02661 15.6179 7.31514 17.2063 8.63314C18.7944 9.95087 19.7915 11.2961 19.8714 11.4055C20.0194 11.6078 20.0194 11.8827 19.8714 12.0852C19.7915 12.1945 18.7944 13.5397 17.2063 14.8574C15.6179 16.1754 13.4406 17.4639 10.9999 17.4639C8.55923 17.4639 6.38191 16.1754 4.79349 14.8574C3.20539 13.5397 2.2083 12.1944 2.12842 12.085C1.98063 11.8825 1.98063 11.6078 2.12842 11.4053C2.20838 11.2959 3.20545 9.95077 4.79349 8.63311C6.38191 7.31514 8.55923 6.02661 10.9999 6.02661Z"
          fill="#3D3D3D"
          stroke="#A6A6A6"
          strokeWidth="0.0351561"
        />
        <path
          d="M7.45679 11.7455C7.45679 9.79201 9.04617 8.20264 10.9997 8.20264C12.9531 8.20264 14.5425 9.79201 14.5425 11.7455C14.5425 13.699 12.9531 15.2883 10.9997 15.2883C9.04617 15.2883 7.45679 13.699 7.45679 11.7455ZM8.60847 11.7455C8.60847 13.064 9.68108 14.1367 10.9997 14.1367C12.3182 14.1367 13.3908 13.064 13.3908 11.7455C13.3908 10.427 12.3182 9.35431 10.9997 9.35431C9.68112 9.35431 8.60847 10.427 8.60847 11.7455Z"
          fill="#3D3D3D"
          stroke="#A6A6A6"
          strokeWidth="0.0351561"
        />
      </svg>
      <div
        title="showLine"
        className={`absolute left-1/2 top-1/2 h-0.5 w-6 origin-center -translate-x-1/2 -translate-y-1/2 -rotate-45 rounded-full bg-[#3D3D3D] transition-all ${
          showLine ? "scale-x-100" : "scale-x-0"
        }`}
      ></div>
    </div>
  );
};

export default EyeIcon;
